
export default {
  name: 'BoutiqueInfos',
  props: {
    boutique: {
      type: Object,
      required: true
    }
  }
}
